import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgData = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-data';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.328 6.299a537 537 0 0 0-4.62 3.197c-.005.012.793.573 1.772 1.246s1.785 1.237 1.791 1.253c.006.017-.79.614-1.768 1.328-.979.713-1.776 1.31-1.771 1.327.011.04 9.219 6.23 9.268 6.23s9.257-6.191 9.267-6.23c.004-.017-.792-.615-1.769-1.33s-1.772-1.312-1.767-1.328c.005-.015.803-.573 1.774-1.24.97-.666 1.763-1.23 1.761-1.252-.005-.052-9.21-6.381-9.276-6.377-.027.001-2.126 1.431-4.662 3.176m7.989.892c1.813 1.248 3.298 2.287 3.299 2.309.003.049-6.582 4.583-6.633 4.567-.106-.033-6.617-4.533-6.608-4.567.011-.037 6.581-4.577 6.625-4.577.011 0 1.504 1.021 3.317 2.268M9.8 14.4c1.184.814 2.174 1.48 2.2 1.48s1.018-.668 2.205-1.484 2.182-1.474 2.211-1.463c.072.028 2.242 1.628 2.252 1.661.012.039-6.598 4.463-6.668 4.463-.058 0-6.675-4.417-6.677-4.457-.001-.027 2.248-1.674 2.291-1.677.018-.002 1.002.663 2.186 1.477"
    })
  }));
});
export default SvgData;